// These are additional function that are used in main.js
import LayerGroup from 'ol/layer/Group';

// bind opacity and visibility inputs
export function bindInputs(layerid, layer) {
    var visibilityInput = $(layerid + ' input.visible');
    visibilityInput.on('change', function () {
        layer.setVisible(this.checked);
    });
    visibilityInput.prop('checked', layer.getVisible());

    var opacityInput = $(layerid + ' input.opacity');
    opacityInput.on('input', function () {
        layer.setOpacity(parseFloat(this.value));
    });
    opacityInput.val(String(layer.getOpacity()));
}

// setup binding of input of sliders
export function setupBindInputs(id, group) {
    group.getLayers().forEach(function (layer, i) {
        var layerid = id + i;
        bindInputs(layerid, layer);
        if (layer instanceof LayerGroup) {
            setupBindInputs(layerid, layer);
        }
    });
}